import React, { useCallback, useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import DVModal from './DVModal';
import EVModal from './EVModal';
import InfoModal from './InfoModal';
import utils from '../../Helpers/FunctionsHelpers';
import Table from '../Table/Table';

import { listOrganizationClients, listOrganizations } from '../Api/Api';

export default function Daily() {
  const [clients, setClients] = useState([]);
  const [clientName, setCllientName] = useState();
  const [show, setShow] = useState(false);
  const [dvShow, setDVShow] = useState(false);
  const [evShow, setEVShow] = useState(false);
  const [clientID, setClientID] = useState(false);

  const [orgList, setOrgList] = useState([]);
  const [orgSelected, setOrgSelected] = useState('');

  const { register } = useForm();
  const navigate = useNavigate();
  const intervalMinutes = 1;

  const columns = [
    {
      title: 'Client Id',
      data: 'client_id',
      className: 'text-center align-middle',
      visible: false,
    },
    {
      title: 'Nome',
      data: 'info_name',
      className: 'text-center align-middle',
    },
    {
      title: 'Urgentes',
      data: 'urgentes',
      className: 'text-center align-middle',
    },
    {
      title: 'Críticas',
      data: 'altas',
      className: 'text-center align-middle',
    },
    {
      title: 'Baixas',
      data: 'baixas',
      className: 'text-center align-middle',
    },
    {
      title: 'Total',
      data: 'total',
      className: 'text-center align-middle',
      render: (data, x, row) => {
        if (data) {
          return `<b>${data}</b>`;
        }
      },
    },
    {
      title: 'Ações',
      data: null,
      className: 'text-center align-middle',
    },
  ];

  const actionButtons = (row) => {
    return (
      row && (
        <>
          <button
            className="btn btn-sm btn-primary m-1"
            onClick={() => toClient(row.client_id)}
          >
            Acesse aqui
          </button>
          <button
            type="button"
            className="btn btn-sm btn-secondary m-1"
            onClick={() => handleShow(row.client_id)}
          >
            Informações
          </button>
          <button
            type="button"
            className="btn btn-sm btn-danger m-1"
            title="Documentos a vencer"
            onClick={() => handleDVShow(row.client_id, row.info_name)}
          >
            <i className="bi bi-calendar-week"></i>
          </button>
          <button
            type="button"
            className="btn btn-sm btn-danger btn-orange m-1"
            title="Eventos a vencer"
            onClick={() => handleEVShow(row.client_id, row.info_name)}
          >
            <i className="bi bi-calendar2-event"></i>
          </button>
        </>
      )
    );
  };

  const filter = useCallback(async (data) => {
    if (data.org === '') {
      data.org = null;
    }

    sessionStorage.setItem('gestao_orgSearch', data.org);
    setOrgSelected(data.org);
    getOrganizationClients(data.org);
  }, []);

  const handleShow = (Client_ID) => {
    setClientID(Client_ID);
    setShow(true);
  };

  const handleDVShow = (Client_ID, Client_Name) => {
    setClientID(Client_ID);
    setCllientName(Client_Name);
    setDVShow(true);
  };

  const handleEVShow = (Client_ID, Client_Name) => {
    setClientID(Client_ID);
    setCllientName(Client_Name);
    setEVShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleDVClose = () => {
    setDVShow(false);
  };

  const handleEVClose = () => {
    setEVShow(false);
  };

  const getOrganizationClients = async (orgId = null) => {
    const res = await listOrganizationClients(orgId);

    if (res.data) {
      setClients(res.data);
    } else {
      setClients([]);
    }
  };

  const getAllOrganizations = async () => {
    const res = await listOrganizations();
    if (res) {
      setOrgList(res.data);
    }
  };

  const toClient = (id) => {
    utils.manageSidebar('close');
    navigate(`/gestao/${id}`);
  };

  useEffect(() => {
    utils.manageSidebar('close');

    setClientID(0);

    getAllOrganizations();

    const savedOrg = sessionStorage.getItem('gestao_orgSearch');

    if (savedOrg) {
      setOrgSelected(savedOrg);
      getOrganizationClients(savedOrg);
    } else {
      getOrganizationClients();
    }

    const interval = setInterval(
      () => {
        const currentOrg = sessionStorage.getItem('gestao_orgSearch');
        getOrganizationClients(currentOrg);
      },
      1000 * 60 * intervalMinutes
    );

    return () => {
      clearInterval(interval);
    };
  }, [filter]);

  return (
    <>
      <main id="main" className="main">
        <div className="pagetitle">
          <div className="card search pt-0">
            <div className="card-body">
              <form>
                <div className="row">
                  <div className="col-md-5 col-xs-12">
                    <label>Organização</label>
                    <select
                      className="form-select"
                      id="org"
                      aria-label="Organização"
                      {...register('org')}
                      value={orgSelected}
                      onChange={(e) => {
                        filter({ org: e.target.value });
                      }}
                    >
                      <option value="">Todos</option>
                      {orgList.length > 0 &&
                        orgList.map((item, index) => {
                          return (
                            <option key={index} value={item.client_id}>
                              {item.organization_name}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <section className="section">
          <div className="col-12">
            <div className="card">
              <div className="card-header">Relação de unidades (diário)</div>
              <div className="card-body scrollBase">
                <Table
                  data={clients}
                  columns={columns}
                  btnColumn={6}
                  actBtns={actionButtons}
                  keepState={true}
                />
              </div>
            </div>
          </div>
        </section>
        <InfoModal show={show} handleClose={handleClose} client_ID={clientID} />
        <DVModal
          show={dvShow}
          handleClose={handleDVClose}
          userName={clientName}
          client_ID={clientID}
        />
        <EVModal
          show={evShow}
          handleClose={handleEVClose}
          userName={clientName}
          client_ID={clientID}
        />
      </main>
    </>
  );
}
